import { Controller } from 'stimulus';

export default class extends Controller {

  static targets = ['category', "userFields", "email", "phone", "sousTraitant", "submit", 'enterprise']

  updateFields() {
    this.userFieldsTarget.classList.remove('d-none');
    this.submitTarget.classList.remove('d-none');
    this.submitTarget.classList.add('d-flex');
    this.categoryTarget.value = event.target.value;
    switch (event.target.value) {
      case 'ree':
        // Hide sous_traitant field
        this.enterpriseTarget.classList.remove('d-none');
        this.sousTraitantTarget.classList.add('d-none');
        this.emailTarget.classList.remove('d-none');
        this.phoneTarget.classList.remove('d-none');
        break;
      case 'inter':
        this.enterpriseTarget.classList.remove('d-none');
        // Hide sous_traitant
        this.sousTraitantTarget.classList.add('d-none');
        // Hide email
        this.emailTarget.classList.add('d-none');
        // Hide phone_number
        this.phoneTarget.classList.add('d-none');
        break;
      case 'inter-st':
        // Hide enterprise ; later on, need to keep this field to make AJAX call and filter Sous traitants
        this.enterpriseTarget.classList.add('d-none');
        // Hide email
        this.emailTarget.classList.add('d-none');
        // Hide phone_number
        this.phoneTarget.classList.add('d-none');
        this.sousTraitantTarget.classList.remove('d-none');
        break;
    }

  }

  searchEnterprises() {
  }

  searchSousTraitants() {
  }
}
